<template>
  <div class="clearfix main_center" >

    <div class="right-content">
      <el-form ref="form" :model="form" label-width="150px" class="form viewFormWrapper">
        <el-card class="box-card" style="margin-bottom: 0px" :style="{'height':cardHight}" >
          <div slot="header" class="clearfix">
            <span>第三方对接系统配置信息</span>
          </div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="系统名称：">
                <span>{{form.systemName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属单位：">
                <span>{{form.orgName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="接口类型：">
                <span>{{form.interTypeName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文件获取方式：">
                <span>{{form.fileDownModName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="所属交易中心：" prop='interType'>
                <el-select v-model="form.tradeId"  style="width:100%;" :disabled="true">
                  <el-option v-for="(item,index) in transactionCenterList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="关联应用：" prop='appId' style="width:100%;">
                <el-select v-model="form.appId" filterable :disabled="true" style="width:100%;">
                  <el-option v-for="(item, index) in appList" :key="item.id" :label="item.appName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
      </el-form>
    </div>
    <div class="left-content">
      <div class="left-navbar">
        <el-button type="primary" size="small" plain style="margin-right:10px;"
                   v-if="hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_add')"
                   @click="routerEdit()">编辑</el-button>
        <el-button size="small" @click="backBtn">返回</el-button>
      </div>
    </div>

  </div>
</template>

<script>

    import {mapState} from "vuex";
    import {tabsCloseCurrentHandle} from '@/utils/routeTab';

    export default {
  components: {

  },
  data(){
    return{
      cardHight:(document.documentElement.clientHeight -108) + 'px',
      form:{
        systemName:'',//系统名称
        orgName:'',//所属单位
        token:'',//访问token
        accessUrl:'',//访问地址
        callback:'',//回调接口
        secrets:'',//接口密钥
        interType:'',//接口类型
        interTypeName:'',//接口类型
        fileDownMod:'',//文件获取方式
        fileDownModName:'',//文件获取方式
        tradeId: '',
        appId: ''
      },
      id:'', //点击提交的时候也传id
      transactionCenterList: [],
    }
  },
  computed: {
    ...mapState({
      stateData:state=>state.user,
      appList:state=>JSON.parse(state.common.appList)
    })
  },
  activated(){
    console.log(this.appList)
    this.id = window.sessionStorage.getItem("id")
    this.getDataById()
    this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));

  },
  methods:{
    backBtn(){ //返回
      tabsCloseCurrentHandle();
      this.$router.push({
        name:'thirds_config_list'
      })
      this.$refs.form.resetFields();
    },
    routerEdit(){
      this.$router.push({
        name:'thirds_config_detail'
      })
    },
    getDataById(){ //详情

      if(this.id != ""){

        this.$http.get('/thirdsConfig/get?id='+this.id).then(res=>{
          if(res.data.code == '1'){
            this.id = res.data.data.id
            const data = res.data.data
            this.form={
              id:this.id,
              systemName:data.systemName ,//系统名称
              orgName:data.orgName ,//所属单位
              token:data.token ,//访问token
              accessUrl:data.accessUrl ,//访问地址
              callback:data.callback ,//回调接口
              secrets:data.secrets ,//接口密钥
              interType:data.interType ,//接口类型
              interTypeName:data.interTypeName ,//接口类型
              fileDownMod:data.fileDownMod,//文件获取方式
              fileDownModName:data.fileDownModName,//文件获取方式
              tradeId: data.tradeId,
              appId: data.appId
            }
          }
        })

      }
    },

  }



}
</script>

<style lang="less" scoped>

</style>